import React from 'react';

export const DoBetButton = ({
  handleDoBetEvents,
  disabledBtn,
  betBtnText,
  cashOutClassname,
  isPulseAnim,
  additionalBtnInfo,
  freeBetRemainingCount,
  isFreeBetDisabled,
  t,
}) => {
  return (
    <div
      className={`pascal-game-col-bottom-bet-wrp bet ${
        isFreeBetDisabled ? 'free-bet-disabled' : ''
      } ${cashOutClassname} ${disabledBtn} ${isPulseAnim}`}
    >
      <button className='btn-game' onClick={handleDoBetEvents}>
        {`${t(betBtnText)} ${freeBetRemainingCount}`}

        {additionalBtnInfo}
      </button>
    </div>
  );
};
